export default function MailIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.385"
      height="21.108"
      viewBox="0 0 26.385 21.108"
      className={`h-6 fill-current ${className}`}
    >
      <g transform="translate(-2.639 -5.277)">
        <path
          d="M2,6.269v16.57a2.269,2.269,0,0,0,2.269,2.269H26.116a2.269,2.269,0,0,0,2.269-2.269V6.269A2.269,2.269,0,0,0,26.116,4H4.269A2.269,2.269,0,0,0,2,6.269Zm21.227.369-8.034,6.24L7.158,6.639Zm1.9,15.831H5.259a.62.62,0,0,1-.62-.62V7.958l10.554,8.219L25.747,7.958V21.85A.62.62,0,0,1,25.127,22.47Z"
          transform="translate(0.639 1.277)"
          fill="#bebebe"
        />
      </g>
    </svg>
  );
}
